import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { BaseTabs, OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { JobCatalogEnumsJobCatalogTreeNodeTypesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { TreeNode, Workplace } from 'modules/cost_centers/components/CostCentersStructure/types'

import { CostCentersStructurePreview } from './Structure'
import { CostCenterAssignmentsPreview } from './Assignments'

const CostCentersPreview = ({
  treeArray,
  workplaces,
  jobStructure,
  expandJobStructure,
  expandWorkplace,
}: {
  treeArray: TreeNode[]
  expandJobStructure: boolean
  expandWorkplace: boolean
  jobStructure?: JobCatalogEnumsJobCatalogTreeNodeTypesEnum
  workplaces: Workplace[]
}) => {
  const [previewTab, setPreviewTab] = useState<string>('structure')

  const hasDimensionSelected = (expandJobStructure && jobStructure) || expandWorkplace

  if (!hasDimensionSelected) {
    return (
      <Box justifyContent="center" alignItems="center" flexGrow>
        <OneEmptyState
          emoji="🍑"
          title={i18n.t('finance.cost_centers_structure.preview.empty.no_dimension.title')}
          description={i18n.t(
            'finance.cost_centers_structure.preview.empty.no_dimension.description'
          )}
        />
      </Box>
    )
  }

  return (
    <>
      <BaseTabs
        tabs={[
          {
            index: true,
            id: 'structure',
            onClick: () => setPreviewTab('structure'),
            label: i18n.t('finance.cost_centers_structure.preview.tabs.structure'),
          },
          {
            id: 'assignments',
            onClick: () => setPreviewTab('assignments'),
            label: i18n.t('finance.cost_centers_structure.preview.tabs.assignments'),
          },
        ]}
      />
      {previewTab === 'structure' && (
        <CostCentersStructurePreview
          treeArray={treeArray}
          jobStructure={jobStructure}
          workplaces={workplaces}
          expandWorkplace={expandWorkplace}
        />
      )}
      {previewTab === 'assignments' && <CostCenterAssignmentsPreview />}
    </>
  )
}

export { CostCentersPreview }
